import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import {
  HtmlNodeElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<HtmlNodeElement>["defaultData"] = {
  attributes: {},
  data: {
    tagName: "span",
  },
};

export const HtmlNode = createBlock<HtmlNodeElement>({
  get name() {
    return t("HtmlNode");
  },
  inlineElement: true,
  defaultData,
  type: ElementType.HTML_NODE,
  create: (payload) => {
    const defaultData: HtmlNodeElement = {
      type: ElementType.HTML_NODE,
      data: {
        tagName: "span",
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.INLINE_TEXT,
  render(params) {
    if (params.mode === "production") {
      return <BasicBlock tag={params.node.data.tagName} params={params} />;
    }
    return (
      <BasicBlock
        tag={params.node.data.tagName || "span"}
        params={{
          ...params,
          node: {
            ...params.node,
            attributes: {
              "element-type": ElementType.HTML_NODE,
              "element-category": ElementCategory.INLINE_TEXT,
              "element-data": encodeURIComponent(
                JSON.stringify(params.node.data)
              ),
              "element-attributes": encodeURIComponent(
                JSON.stringify(params.node.attributes)
              ),
            } as any,
          },
        }}
      />
    );
  },
});
